// Safety net: rendered only if the layout API is unreachable, so the homepage is never blank.
export const FALLBACK_HOME = [
    {
        id: "section_home_hero", type: "hero", name: "Hero", visible: true,
        props: {
            eyebrow: "Nutraceutical For Men",
            title_top_prefix: "Live", title_top_accent: "Better",
            title_bottom_prefix: "Live", title_bottom_accent: "Stronger",
            body: "Meet ReDrive Max — a scientifically-formulated effervescent powered by KSM-66 Ashwagandha, Testofen and 8 more botanical actives across three formulation combos.",
            tagline: "Drop · Fizz · Drink · Drive your best.",
            primary_label: "Buy ReDrive Max", primary_href: "/product/redrive-max",
            secondary_label: "Learn the Science", secondary_href: "/science",
            badges: ["No Added Sugar", "No Artificial Colours", "Gentle on Stomach"],
            product_slug: "redrive-max", show_product_card: true,
        },
    },
    {
        id: "section_home_marquee", type: "marquee", name: "Scrolling band", visible: true,
        props: { items: ["Powered by Nature", "Backed by Science", "Zesty Lime Flavor", "Drop · Fizz · Drink", "Drive Your Best"] },
    },
    {
        id: "section_home_formulation", type: "formulation", name: "Formulation & actives", visible: true,
        props: { eyebrow: "Science of Nature", heading: "10 Potent Herbal Actives.\nOne Daily Effervescent.", product_slug: "redrive-max" },
    },
    {
        id: "section_home_testimonials", type: "testimonials", name: "Testimonials", visible: true,
        props: { eyebrow: "Real Men. Real Results.", heading: "Trusted by guys who refuse to slow down.", product_slug: "redrive-max", limit: 6 },
    },
];
